import { supabase } from "../supabase/SupabaseClient";
import { actual } from "./quien";
import { traerTodas } from "./paginar";

// Se re-exporta lo puro para que la pantalla importe de un solo lado.
export { NIVELES, nivelDe, dotDe, rotuloCalif } from "../shared/calificacion";

/* P-171: la calificación de empleado que carga RRHH (bueno/regular/malo).
 *
 * QUIÉN LEE Y ESCRIBE LO DECIDE LA BASE. `ver.rrhh` para leer, `cargar.rrhh`
 * para escribir (RLS de `personal_calificacion`). Sin la llave, Supabase
 * devuelve cero filas o rechaza el upsert; la pantalla sólo decide cómo
 * mostrarlo.
 *
 * NO PASA POR `createRow`/`updateRow`: la tabla no tiene `usuario`/
 * `usuario_nombre` sino `actualizado_por`, así que el autor se sella acá con
 * `actual()`. Su clave es `dni`, no `id`, por eso el upsert va `onConflict:dni`.
 */

const CAMPOS = "dni,nota,motivo,actualizado_en,actualizado_por";

/* Todas las calificaciones, indexadas por DNI (string). `{}` si no hay o no se
 * puede leer sin la llave — un mapa vacío no rompe la nómina, sólo no dibuja
 * puntitos. Se pagina por si algún día son más de mil. */
export async function traerCalificaciones() {
  const filas = await traerTodas(() =>
    supabase
      .from("personal_calificacion")
      .select(CAMPOS, { count: "exact" })
      .order("dni"),
  );
  const porDni = {};
  for (const f of filas || []) porDni[String(f.dni)] = f;
  return porDni;
}

/* Pone (o cambia) la calificación de una persona. Upsert por DNI: calificar de
 * nuevo pisa la anterior, que es lo que se quiere —una persona tiene UNA
 * calificación vigente—. Devuelve la fila guardada. */
export async function setCalificacion(dni, nota, motivo = null) {
  const yo = actual();
  const fila = {
    dni: String(dni),
    nota,
    motivo: (motivo || "").trim() || null,
    actualizado_en: new Date().toISOString(),
    actualizado_por: yo?.mail || null,
  };
  const { error } = await supabase
    .from("personal_calificacion")
    .upsert(fila, { onConflict: "dni" });
  if (error) throw error;
  return fila;
}

/* Saca la calificación (vuelve a «sin calificar»). Se ofrece porque una
 * calificación puesta por error tiene que poder retirarse, no sólo cambiarse. */
export async function quitarCalificacion(dni) {
  const { error } = await supabase
    .from("personal_calificacion")
    .delete()
    .eq("dni", String(dni));
  if (error) throw error;
}
